import styled from 'styled-components';
import { Button, Card } from 'react-bootstrap';
import { actionButton, panel, cardSurface, border, surface, mutedSurface, ink, accent } from '../UI/tokens';

export const ButtonCard = styled(Button).attrs({ className: "ui-action-custom" })`
  ${actionButton}
  && { flex: 0 1 auto; width: auto; min-height: 36px; padding: 8px 12px; margin: 0; white-space: normal; }
  @media (max-width: 576px) { && { flex: 1 1 120px; } }
`;
export const SpanCard = styled.span`
  margin: 0; line-height: 1.35;
`;
export const CardTela = styled(Card)`
  ${panel}
  ${cardSurface}
  height: auto; min-height: 520px; max-height: none;
  flex: 1 1 auto; width: 100%; min-width: 0;
  display: flex; flex-direction: column; margin: 12px 0 20px;
  border-radius: 14px; border-top: 3px solid ${accent};
  font-family: var(--ui-font); font-size: 13px;
  box-shadow: 0 4px 16px rgba(15,23,42,.07);
  & > .card-header {
    flex: 0 0 auto; min-height: 58px; padding: 14px 18px; gap: 12px;
    background: ${mutedSurface}; color: ${ink};
    border-bottom: 1px solid ${border}; border-radius: 11px 11px 0 0;
    font-size: 14px; font-weight: 700;
  }
  & > .card-header:empty { display: none; }
  & > .card-header .btn-link {
    flex-shrink: 0; padding: 6px 10px; font-size: 12px;
    text-decoration: none; border: 1px solid ${border}; border-radius: 7px; color: ${ink};
  }
  & > .card-body { flex: 1 0 auto; min-height: auto; padding: 18px; overflow: visible; }
  /* Somente os blocos diretos; não atinge Rows/Cols internos de renderizadores customizados. */
  & > .card-body > div > div { padding: 6px 0; line-height: 1.6; }
  & > .card-body > div > div:first-child { padding-top: 0; }
  & > .card-body > div > div:last-child { padding-bottom: 0; border-bottom: 0; }
  & > .card-body > div > div > div > strong { font-weight: 600; font-size: 12px; }
  & > .card-footer {
    flex: 0 0 auto; display: flex; flex-wrap: wrap; align-items: center; gap: 8px;
    margin-top: auto; padding: 14px 18px; border-top: 1px solid ${border};
    background: ${mutedSurface}; border-radius: 0 0 14px 14px;
  }
  /* Base uniforme; conteúdo e detalhes expandem o card, sem scroll no corpo. */
`;
